import { Input, type InputProps } from '@/components/common/Input';
import { validateUrl } from '../validation';

interface UrlInputProps extends Omit<InputProps, 'type' | 'error'> {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

/**
 * URL input with live feedback. Same rule as EmailInput: empty value is
 * never considered invalid; non-empty values are parsed with new URL() and
 * must use http or https.
 */
export function UrlInput({ value, onChange, error, ...rest }: UrlInputProps) {
  const liveError =
    value.length > 0 && !validateUrl(value) ? 'URL must start with http:// or https://' : undefined;
  return (
    <Input type="text" value={value} onChange={onChange} error={error ?? liveError} {...rest} />
  );
}
